var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "tools" }, [
        _c(
          "div",
          { staticClass: "button" },
          [
            _c(
              "bk-button",
              {
                staticClass: "mr10",
                attrs: { theme: "default", type: "submit", title: "基础按钮" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.prePage.apply(null, arguments)
                  },
                },
              },
              [
                _c("el-button", { attrs: { type: "success" } }, [
                  _vm._v("上一页"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "page" }, [
              _vm._v(_vm._s(_vm.pageNum) + "/" + _vm._s(_vm.pageTotalNum)),
            ]),
            _vm._v(" "),
            _c(
              "bk-button",
              {
                staticClass: "mr10",
                attrs: { theme: "default", type: "submit", title: "基础按钮" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.nextPage.apply(null, arguments)
                  },
                },
              },
              [
                _c("el-button", { attrs: { type: "success" } }, [
                  _vm._v("下一页"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("pdf", {
        ref: "wrapper",
        attrs: { src: _vm.url, page: _vm.pageNum, rotate: _vm.pageRotate },
        on: {
          progress: function ($event) {
            _vm.loadedRatio = $event
          },
          "page-loaded": function ($event) {
            return _vm.pageLoaded($event)
          },
          "num-pages": function ($event) {
            _vm.pageTotalNum = $event
          },
          error: function ($event) {
            return _vm.pdfError($event)
          },
          "link-clicked": function ($event) {
            _vm.page = $event
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "button" }, [
        _c("div", { staticClass: "icon-button-a" }, [
          _c("div", { on: { click: _vm.scaleD } }, [
            _c("img", {
              staticClass: "icon-button",
              attrs: { src: require("../../images/icon/da.png"), alt: "" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { on: { click: _vm.scaleX } }, [
            _c("img", {
              staticClass: "icon-button",
              attrs: { src: require("../../images/icon/xiao.png"), alt: "" },
            }),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }